import React from 'react';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
interface BlogCardProps {
  title: string;
  excerpt: string;
  slug: string;
  date: string;
  readTime: string;
}
export function BlogCard({
  title,
  excerpt,
  slug,
  date,
  readTime
}: BlogCardProps) {
  return <a href={`/blog/${slug}`} onClick={e => {
    e.preventDefault();
    window.history.pushState({}, '', `/blog/${slug}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo(0, 0);
  }} className="group flex flex-col h-full bg-[#0a0a0a] border border-white/[0.06] rounded-xl overflow-hidden hover:border-[#c9a84c]/40 transition-all duration-300" data-id="element-84">
      <div className="p-6 flex flex-col flex-1" data-id="element-85">
        <div className="flex items-center space-x-4 text-xs text-white/40 mb-4" data-id="element-86">
          <div className="flex items-center space-x-1" data-id="element-87">
            <Calendar className="w-3 h-3" data-id="element-88" />
            <span data-id="element-89">{date}</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-90">
            <Clock className="w-3 h-3" data-id="element-91" />
            <span data-id="element-92">{readTime}</span>
          </div>
        </div>

        <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#c9a84c] transition-colors" data-id="element-93">
          {title}
        </h3>

        <p className="text-white/60 text-sm leading-relaxed mb-6 flex-1" data-id="element-94">
          {excerpt}
        </p>

        <div className="flex items-center text-[#c9a84c] text-sm font-medium mt-auto" data-id="element-95">
          <span data-id="element-96">Read Article</span>
          <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-97" />
        </div>
      </div>
    </a>;
}